/** @flow */

import {
  GetAbsenceMonitoringList,
  GetAbsenceMonitoringListSuccess,
  GetAbsenceMonitoringListError,
  GetAbsenceMonitoring,
  GetAbsenceMonitoringSuccess,
  GetAbsenceMonitoringError,
  GetAbsenceMonitoringSchema,
  GetAbsenceMonitoringSchemaSuccess,
  GetAbsenceMonitoringSchemaError,
  NewAbsenceMonitoring,
  SetAbsenceMonitoringDraft,
  NewAbsenceMonitoringAssignments,
  SetAbsenceMonitoringAssignments,
  SetAbsenceMonitoringDraftAssignments,
  UpdateAbsenceMonitoring,
  UpdateAbsenceMonitoringSuccess,
  UpdateAbsenceMonitoringError,
  AddAbsenceMonitoring,
  AddAbsenceMonitoringSuccess,
  AddAbsenceMonitoringError,
  ResetAbsenceMonitoringState,
} from "@modules/service/constants/actions";
import * as absenceMonitoringReducers from "./reducers";
import initialState from "./state";
import type { AbsenceMonitoringState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: AbsenceMonitoringState = initialState,
  action: Object,
): AbsenceMonitoringState => {
  const act = {
    [UpdateAbsenceMonitoring]: absenceMonitoringReducers.onUpdateAbsenceMonitoring,
    [UpdateAbsenceMonitoringSuccess]: absenceMonitoringReducers.onUpdateAbsenceMonitoringSuccess,
    [UpdateAbsenceMonitoringError]: absenceMonitoringReducers.onUpdateAbsenceMonitoringError,
    [AddAbsenceMonitoring]: absenceMonitoringReducers.onUpdateAbsenceMonitoring,
    [AddAbsenceMonitoringSuccess]: absenceMonitoringReducers.onUpdateAbsenceMonitoringSuccess,
    [AddAbsenceMonitoringError]: absenceMonitoringReducers.onUpdateAbsenceMonitoringError,
    [ResetAbsenceMonitoringState]: absenceMonitoringReducers.onResetAbsenceMonitoringState,

    [GetAbsenceMonitoringList]: absenceMonitoringReducers.onGetAbsenceMonitoringList,
    [GetAbsenceMonitoringListSuccess]: absenceMonitoringReducers.onGetAbsenceMonitoringListSuccess,
    [GetAbsenceMonitoringListError]: absenceMonitoringReducers.onGetAbsenceMonitoringListError,

    [GetAbsenceMonitoring]: absenceMonitoringReducers.onGet,
    [GetAbsenceMonitoringSuccess]: absenceMonitoringReducers.onGetSuccess,
    [GetAbsenceMonitoringError]: absenceMonitoringReducers.onGetError,
    [GetAbsenceMonitoringSchema]: absenceMonitoringReducers.onGetSchema,
    [GetAbsenceMonitoringSchemaSuccess]: absenceMonitoringReducers.onGetSchemaSuccess,
    [GetAbsenceMonitoringSchemaError]: absenceMonitoringReducers.onGetSchemaError,
    [NewAbsenceMonitoring]: absenceMonitoringReducers.onNew,
    [SetAbsenceMonitoringDraft]: absenceMonitoringReducers.onSetDraft,
    [NewAbsenceMonitoringAssignments]: absenceMonitoringReducers.onNewAssignments,
    [SetAbsenceMonitoringAssignments]: absenceMonitoringReducers.onSetAssignments,
    [NewAbsenceMonitoringAssignments]: absenceMonitoringReducers.onNewAssignments,
    [SetAbsenceMonitoringDraftAssignments]:
      absenceMonitoringReducers.onSetAbsenceMonitoringDraftAssignments,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
